export const randomSeed = 999999;

export const articleDescriptionMaxLength = 20;
